import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

export default function Testimonials({ site }) {
    return (
        <section
            data-testid="testimonials-section"
            className="relative bg-ink-900 py-24 md:py-36"
        >
            <div className="mx-auto max-w-[1400px] px-5 md:px-10">
                <div className="mb-14 md:mb-20">
                    <div className="font-mono-label text-lime-signal mb-4">05 — Word of mouth</div>
                    <h2 className="font-display uppercase leading-[0.9] text-5xl md:text-7xl">
                        <span className="text-white">Backed by</span>
                        <br />
                        <span className="text-lime-signal">the block.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
                    {site.testimonials.map((t, i) => (
                        <motion.blockquote
                            key={t.name + i}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.7, delay: i * 0.1 }}
                            data-testid={`testimonial-${i}`}
                            className="card-tactical p-8 md:p-10 flex flex-col justify-between min-h-[280px]"
                        >
                            <div>
                                <Quote className="w-8 h-8 text-lime-signal mb-6" strokeWidth={1.4} />
                                <p className="text-white/85 text-lg md:text-xl leading-snug font-medium">
                                    &ldquo;{t.quote}&rdquo;
                                </p>
                            </div>
                            <div className="mt-8 flex items-center justify-between">
                                <div>
                                    <div className="text-white font-semibold">{t.name}</div>
                                    <div className="font-mono-label text-white/40 mt-1">{t.city}</div>
                                </div>
                                <div className="flex gap-0.5">
                                    {Array.from({ length: t.rating || 5 }).map((_, j) => (
                                        <Star key={j} size={14} className="text-lime-signal" fill="currentColor" />
                                    ))}
                                </div>
                            </div>
                        </motion.blockquote>
                    ))}
                </div>
            </div>
        </section>
    );
}
